import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { ApiCallService } from "../../../api/service/api-call.service";
import * as Constants from "../../../constant/Constants";

import * as _moment from "moment";
import { default as _rollupMoment, Moment } from "moment";
import { ValidationService } from "src/app/services/validation.service";
import { CurrencyPipe } from "@angular/common";
import { createSumInsuredValidator } from "src/app/validators/custom.validators";
import {MatDialog} from '@angular/material/dialog';
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { decodeLogbookJWTToken, TokenData } from "src/app/util/HelperFunctions";

const moment = _rollupMoment || _moment;

@Component({
  selector: "app-page-one",
  templateUrl: "./quote-details.component.html",
  styleUrls: ["./quote-details.component.css"],
})
export class QuoteDetailsComponent implements OnInit {
  VehicleMakePlaceHolders: any = [];
  VehicleModelPlaceHolders: any = [];

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  // Url Params
  journey: string = "new"; // new, existing ... etc.
  insurance: string = "private"; // private, commercial, special, motorcycle ... etc.
  type:string = "own"; // own | general    // only for commercial
  action: string = "buy"; // buy, renew ... etc.
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++
  // data from token
  tokenData: TokenData | 'error' = 'error';

  // Change according to insurance type
  pageHeading: string = "Private vehicle motor insurance application";
  benefitsHeading: string = "Additional premium for the additional benefits selected";
  benefitsSubheading: string =
    "Please select any additional benefits you would like us to add to your cover";
  currencyKE: string = "KES";
  vehicleDetails: string = "Enter Vehicle Details";
  vehicleMakeLabel: string = "Select Vehicle Make";
  vehicleModelLabel: string = "Select Vehicle Model";
  yearManufacturedLabel: string = "Select Year of Manufacture";
  carValueLabel: string = "Value of Car";
  protectorBenText: string =
    "<b>Excess Protector Own Damage</b><br>This protects you from paying excess for your own damages in case of accident or fire.<br>A claim is payable/Admissible if the damage is at least <b>2.5%</b> of the sum insured, minimum Ksh 15,000/=";
  theftBenText: string =
    "<b>Excess Protector Theft</b><br>This protects you from paying excess in the event your car is stolen";
  politicalBenText: string =
    "<b>Political violence and terrorism</b><br>This covers damages incurred from political violence and terrorism";
  courCarBenText: string =
    "<b>Courtesy Car</b><br>Receive an alternative car while your car is being repaired";
  passengerLiability: string =
    "<b>Passenger Legal Liability</b><br>This covers you against any legal responsibility you have towards your non-paying passengers in an accident while driving";
  windBenText: string =
    "<b>Windscreen above Ksh. 50,000</b><br>If you want to insure your windscreen above Ksh. 50,000 free limit";
  entBenText: string =
    "<b>Entertainment unit above Ksh. 50,000</b><br>If you want to insure your entertainment unit above Ksh. 50,000 free limit";

  windscreenAmountLabel: string = "Enter windscreen insurance amount";
  entertainmentAmountLabel: string = "Enter entertainment insurance amount";
  courtesy30kLabel: string = "10 Days";
  courtesy60kLabel: string = "20 Days";
  courtesyLimit30Desc: string = "Cappped at Ksh. 30,000 for 10 days";
  courtesyLimit60Desc: string = "Cappped at Ksh. 60,000 for 20 days";
  passengersLabel: string = "Maximum number of passengers";
  tonnageLabel: string = "Tonnage (load capacity)";
  cancel: string = "Cancel";
  saveContinue: string = "Save and Continue";

  requiredFieldString: string = "This field is required";

  minDate: Date;
  maxDate: Date;
  formErrors: { [key: string]: string } = {
    vehicleMake: "",
    vehicleModel: "",
    passengers: "",
    tonnage: "",
    carValue: "",
    windscreenAmount: "",
    entertainmentAmount: "",
  };
  formGroupErrors: { [key: string]: string } = {
    courtesyCarLimit: "",
  };
  validationMessages: { [key: string]: {} } = {
    vehicleMake: { required: this.requiredFieldString },
    vehicleModel: { required: this.requiredFieldString },
    passengers: { required: this.requiredFieldString,min:'Invalid input',max:'Vehicles above 70 passengers are not covered' },
    tonnage: { required: this.requiredFieldString, min:'Invalid vehicle weight', max:'Vehicles exceeding 5 Tonnes are not covered' },
    carValue: { required: this.requiredFieldString, cMin: "Minimum sum insurable is KES 500,000" },
    courtesyCarLimit: {required: 'You must select an option to continue'},
    windscreenAmount: { required: this.requiredFieldString, cMin: "Minimum amount must be above KES 50,000", cMax: "Maximum valid amount is KES 1,000,000" },
    entertainmentAmount: { required: this.requiredFieldString, cMin: "Minimum amount must be above KES 50,000", cMax: "Maximum valid amount is KES 1,000,000" },
  };
  validationMessagesMotorcycle: { [key: string]: {} } = {
    vehicleMake: { required: this.requiredFieldString },
    vehicleModel: { required: this.requiredFieldString },
    passengers: { required: this.requiredFieldString,min:'Invalid input',max:'Vehicles above 70 passengers are not covered' },
    tonnage: { required: this.requiredFieldString,min:'Invalid vehicle weight',max:'Vehicles exceeding 5 Tonnes are not covered' },
    carValue: { required: this.requiredFieldString, cMin: "Minimum sum insurable is KES 80,000" },
    courtesyCarLimit: {required: 'You must select an option to continue'},
    windscreenAmount: { required: this.requiredFieldString, cMin: "Minimum amount must be above KES 50,000", cMax: "Maximum valid amount is KES 1,000,000" },
    entertainmentAmount: { required: this.requiredFieldString, cMin: "Minimum amount must be above KES 50,000", cMax: "Maximum valid amount is KES 1,000,000" },
  };
  
  
  motorForm = this._formBuilder.group({
    // vehicleMake: [""],
    // vehicleModel: [""],
    // yearManufactured: [moment(), Validators.required],

    // // Commercial vehicles only
    // passengers: ["", ],
    // tonnage: ["", ],

    // carValue: [""],

    benefits: this._formBuilder.group({
      ownDamageProtector: false,
      theftProtector: false,
      politicalViolence: false,

      courtesyCar: false,
      courtesyCarLimit: this._formBuilder.group({
        tenDays: true,
        twentyDays: false,
      }),
      passLiability: false,

      windscreen: false,
      windscreenAmount: [""],

      entertainment: false,
      entertainmentAmount: [""],
    }),
  });

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private apiCallService: ApiCallService,
    private validationService: ValidationService,
    private currencyPipe: CurrencyPipe,
    public dialog: MatDialog
  ) {
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 15);

    this.minDate = tempDate;
    this.maxDate = currentDate;
  }

  newUser: boolean = false;
  hiddenFields: boolean = false;
  showOnlyBenefits: boolean = false;
  showBenefits: boolean = true;
  enableAltView: boolean = false;

  url: string = environment.baseUrl + Constants.quotePrivateURL;
  paramsObject: Object = "";

  loading: boolean = false;

  carMakeIsEmpty: boolean = true;
  carModelsEmpty: boolean = true;
  loadingMake: boolean = false;
  loadingModel: boolean = false;

  formScrolled: boolean = false;
  courtseyCarLimitDesc: string = this.courtesyLimit30Desc;

  // Run during page initialisation
  ngOnInit(): void {
    this.motorForm.get('benefits')?.get('windscreen')?.valueChanges.subscribe(value => {
      const windscreenAmount = this.motorForm.get('benefits')?.get('windscreenAmount')
      this.validationService.addOrRemoveCurrenciedValidator(value!,windscreenAmount!)
    })
    this.motorForm.get('benefits')?.get('entertainment')?.valueChanges.subscribe(value => {
      const entertainmentAmount = this.motorForm.get('benefits')?.get('entertainmentAmount')
      this.validationService.addOrRemoveCurrenciedValidator(value!,entertainmentAmount!)
    });
   
    this.route.queryParams.subscribe((params) => {
      if (!environment.production) console.log('Params---> ',params); // log route params
      if (params["token"] !== 'undefined') {
        this.token = params["token"];
        // Autofill available data on form controls
        try {
          this.tokenData = decodeLogbookJWTToken(this.token);
          // this.getCarMakeList();

          if ((this.tokenData && this.tokenData.additionalData )) {
            const additionalData = this.tokenData.additionalData;
            const is20Days: boolean = additionalData.courtesyCarLimit == '20';

            this.motorForm.patchValue({
              benefits: {
                ownDamageProtector: additionalData.ownDamageProtector || false,
                theftProtector: additionalData.theftProtector || false,
                politicalViolence: additionalData.politicalViolence || false,
                courtesyCar: additionalData.courtesyCar || false,
                courtesyCarLimit: {
                  tenDays: !is20Days,
                  twentyDays: is20Days,
                },
                passLiability: false,
                windscreen: additionalData.windscreen || false,
                windscreenAmount: additionalData.windscreenAmount || "",
                entertainment: additionalData.entertainment || false,
                entertainmentAmount: additionalData.entertainmentAmount || "",
              }
            });
          }
        } catch (error) {console.error(':: Error ! ', error);}
      }

      // Handle journey page param
      if (params["journey"] !== undefined) {
        this.journey = params["journey"];

        if (params["journey"] === "new") {
          this.newUser = true;
        }
      }

      if (params["type"] !== undefined) {
        this.type = params["type"];
      }

      // Handle insurance page param
      if (params["insurance"] !== undefined) {
        this.insurance = params["insurance"];

        this.pageHeading =
          this.insurance[0].toUpperCase() +
          this.insurance.substring(1).toLowerCase() +
          " vehicle motor insurance application";

        if (params["journey"] === "renewal") {
          this.showOnlyBenefits = true;
        }

        if (params["insurance"] === "commercial") {
          this.carValueLabel = "Value of Vehicle";
          this.hiddenFields = true;
          this.url = environment.baseUrl + Constants.quoteCommercialURL;

        } else if (params["insurance"] === "special") {
          this.pageHeading = "Special type vehicle motor insurance application";
          this.passengersLabel = "Passenger Limit";
          this.tonnageLabel = "Tonnes";

          this.hiddenFields = true;
          this.url = environment.baseUrl + Constants.quoteSpecialURL;

          if (params["journey"] === "existing") {
            this.showBenefits = false;
          }

        } else if (params["insurance"] === "motorcycle") {
          this.pageHeading = "Motorcycle insurance application";
          this.vehicleDetails = "Enter Motorcycle Details";
          this.vehicleMakeLabel = 'Select Motorcycle Make';
          this.vehicleModelLabel = 'Select Motorcycle Model';
          this.carValueLabel = "Value of Motorcycle";

          this.url = environment.baseUrl + Constants.quoteMotorcycleURL;

          if (params["journey"] === "existing") {
            this.showBenefits = false;
          }
        }
      }

      // Handle action page param
      if (params["action"] !== undefined) {
        this.action = params["action"];

        if (
          (params["journey"] === "existing" &&
            params["action"] === "renew") ||
            params["action"] === "endorse"
        ) {
          this.enableAltView = false;

        } 
       /*  else {
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("vehicleMake")!
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("vehicleModel")!
          );
          if (this.insurance === "motorcycle") {
            this.validationService.addSumInsuredValidator(
              true,
              this.motorForm.get("carValue")!,
              true
            );
          } else {
            this.validationService.addSumInsuredValidator(
              true,
              this.motorForm.get("carValue")!,
              false
            );
          }
          
        } */
        
      }

    this. enableHiddenFieldsValidation()
    });

    //log Errors on load
    this.motorForm.valueChanges.subscribe((form) => {
      if (this.insurance === 'motorcycle') {this.logErrorsMotorcycle()}
      else {this.logErrors()}

      /* if (form.passengers) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          passengers: form.passengers.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.tonnage) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          tonnage: form.tonnage.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.carValue) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          carValue: this.currencyPipe.transform(form.carValue.replace(/\D/g, '').replace(/^0+/, ''), 'KES  ', 'symbol', '1.0-0')
        }, {emitEvent: false});
      } */
      if (form.benefits?.windscreenAmount) {
        this.motorForm.controls['benefits'].patchValue({
          windscreenAmount: this.currencyPipe.transform(form.benefits.windscreenAmount.replace(/\D/g, '').replace(/^0+/, ''), 'KES  ', 'symbol', '1.0-0')
        }, {emitEvent: false});
      }
      if (form.benefits?.entertainmentAmount) {
        this.motorForm.controls['benefits'].patchValue({
          entertainmentAmount: this.currencyPipe.transform(form.benefits.entertainmentAmount.replace(/\D/g, '').replace(/^0+/, ''), 'KES  ', 'symbol', '1.0-0')
        }, {emitEvent: false});
      }
    });

    this.validationService.subcribeToControlChanges(
      "courtesyCarLimit",
      this.motorForm.controls['benefits'],
      this.formGroupErrors,
      this.validationMessages
    );
  }

  // onFormScroll(event: Event) {
  //   this.formScrolled = event.target.scrollTop > 0;
  // }
  
 /*  async getCarMakeList() {
    this.loadingMake = true;
    const response = await this.apiCallService.getRequest(
      environment.baseUrl + Constants.vehicleMakeURL
    );

    const isResponseValid = this.checkArrayStringType(response);

    if (isResponseValid) {
      this.VehicleMakePlaceHolders = response;
      this.carMakeIsEmpty = false;
      this.loadingMake = false;

      if ((this.tokenData !== 'error' &&
        this.tokenData &&
        this.tokenData.additionalData &&
        this.tokenData.additionalData.MakeofVehicle )) {
        // console.log('???????????? setting make : ', this.tokenData.additionalData.MakeofVehicle);
        this.motorForm.patchValue({
          vehicleMake: this.compareVehicleDetailsToFromAPI(this.tokenData.additionalData.MakeofVehicle, this.VehicleMakePlaceHolders),
        });

        if (!(this.motorForm.value.vehicleMake === '')) {
          this.populateCarModelList();
        }
      }
    } else {
      this.loadingMake = false;
    }
    
  } */

/*   async populateCarModelList() {
    this.VehicleModelPlaceHolders = [""];
    this.loadingModel = true;
    
    const carMakeValue = this.motorForm.controls["vehicleMake"].value;

    const vhmodelRequest = {
      carMake: carMakeValue,
    };

    const response = await this.apiCallService.postRequest(
      environment.baseUrl + Constants.vehicleModelURL,
      vhmodelRequest
    );

    const isResponseValid = this.checkArrayStringType(response);

    if (!isResponseValid) {
      this.carModelsEmpty = true;
      this.loadingModel = false;

    } else {
      this.VehicleModelPlaceHolders = response.filter(function(entry: string) { return entry.trim() != ''; }); // Trim empty string entries
      this.carModelsEmpty = false;

      if (
        this.tokenData !== 'error' &&
        this.tokenData &&
        this.tokenData.additionalData &&
        this.tokenData.additionalData.Model &&
        carMakeValue === this.tokenData.additionalData.MakeofVehicle.toUpperCase() &&
        this.motorForm.get('vehicleModel')?.pristine
        ) {

          let model;
          if (this.tokenData.additionalData.Model === '') {
            const altModel = this.tokenData.additionalData.MakeofVehicle.split(' ', 2);
            if (altModel[1]) {
              model = this.compareVehicleDetailsToFromAPI(
                altModel[1],
                this.VehicleModelPlaceHolders);
            }

          } else {
            model = this.compareVehicleDetailsToFromAPI(
              this.tokenData.additionalData.Model,
              this.VehicleModelPlaceHolders);
          }
  
        // console.log('???????????? setting model : ', this.tokenData.additionalData.Model);
        this.motorForm.patchValue({
          vehicleModel: model,
        });
  
        // console.log('???????????? New model : ', this.motorForm.value.vehicleModel);
  
      }

      this.loadingModel = false;
    }
  } */

  compareVehicleDetailsToFromAPI(value: string, items: string[]): string {
    try {
      for (let i=0; i<items.length; i++) {
        // console.log('>><< Comparing value : ', value.toLowerCase(), ' to item : ',  items[i].toLowerCase());
        if (value.toLowerCase().replace(/\s/g, '').includes(items[i].toLowerCase().replace(/\s/g, '')) ||
          value.toLowerCase().replace(/\s/g, '') === items[i].toLowerCase().replace(/\s/g, '')) {
          // console.log('>><< Matching value : ', items[i]);
          return items[i];
        }
      }
      return '';

    } catch (error) {
      console.log('>><< Error ! ', error);
      return '';
    }
  }

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      quoteNumber: "1",
      classCode: "970",
      classOfUse: this.insurance,
      typeOfCover: "COMP",
      journey: this.journey+'_'+this.action,
      // make: this.motorForm.controls["vehicleMake"].value,
      // model: this.motorForm.controls["vehicleModel"].value,
      // yom: this.motorForm.controls["yearManufactured"].value!.format("YYYY"),
      // carValue: this.motorForm.controls["carValue"].value?.replace(/\D/g,''),

      // Benefits
      windscreen:
        this.motorForm.controls["benefits"].controls["windscreen"].value ===
        true
          ? "Y"
          : "N",
      windscreenAmount:
        this.motorForm.controls["benefits"].controls["windscreen"].value ===
        true
          ? this.motorForm.controls["benefits"].controls["windscreenAmount"].value?.replace(/\D/g,'')
          : '50000',

      entertainment:
        this.motorForm.controls["benefits"].controls["entertainment"].value ===
        true
          ? "Y"
          : "N",
      entertainmentAmount:
        this.motorForm.controls["benefits"].controls["entertainment"].value ===
        true
          ? this.motorForm.controls["benefits"].controls["entertainmentAmount"].value?.replace(/\D/g,'')
          : '50000',

      courtesyCar:
        this.motorForm.controls["benefits"].controls["courtesyCar"].value === true
          ? "Y"
          : "N",
      courtesyCarLimit: this.motorForm.controls["benefits"].controls["courtesyCar"].value === false ? null :
        this.motorForm.controls["benefits"].controls["courtesyCarLimit"].controls['tenDays'].value === true ?
        '10 Days' : '20 Days',
      excessOwnDamage:
        this.motorForm.controls["benefits"].controls["ownDamageProtector"]
          .value === true
          ? "Y"
          : "N",
      excessTheft:
        this.motorForm.controls["benefits"].controls["theftProtector"].value ===
        true
          ? "Y"
          : "N",
      pvt:
        this.motorForm.controls["benefits"].controls["politicalViolence"]
          .value === true
          ? "Y"
          : "N",
      passengerLiability:
        this.motorForm.controls["benefits"].controls["passLiability"].value ===
        true
          ? "Y"
          : "N",

      // Commercial vehicles only
      // passengers: this.motorForm.controls["passengers"].value,
      // tonnage: this.motorForm.controls["tonnage"].value,
      token: this.token,
      filled: true,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'Cancel',
          'Try again'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'Cancel',
        'Try again'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
    
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }
  
  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }
  logErrorsMotorcycle() {
    this.formErrors = this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessagesMotorcycle
    );
  }

  enableHiddenFieldsValidation() {
    // debugger
    const tonnageControl = this.motorForm.get('tonnage')
    const passengersControl = this.motorForm.get('passengers')
    if(this.hiddenFields){
      if (this.type === "general") {
        tonnageControl?.setValidators([Validators.required, Validators.min(1),Validators.max(5)])
      } else {
        tonnageControl?.setValidators([Validators.required, Validators.min(1)])
      }
      
      passengersControl?.setValidators([Validators.required, Validators.min(1),Validators.max(70)])
    }
    else {
        tonnageControl?.clearValidators()
        passengersControl?.clearValidators()
    }
  }
  
  onCourtesy10Change() {
    this.courtseyCarLimitDesc = this.courtesyLimit30Desc;
    this.motorForm.controls["benefits"].controls["courtesyCarLimit"].controls["twentyDays"].setValue(false);
  }

  onCourtesy20Change() {
    this.courtseyCarLimitDesc = this.courtesyLimit60Desc;
    this.motorForm.controls["benefits"].controls["courtesyCarLimit"].controls["tenDays"].setValue(false);
  }

  clearWindscreenVal() {
    if (!this.motorForm.controls["benefits"].controls["windscreen"].value) {
      this.motorForm.controls["benefits"].controls["windscreenAmount"].setValue(null);
      this.motorForm.controls["benefits"].controls["windscreenAmount"].clearValidators();
    }
  }
  clearEntertainmentVal() {
    if (!this.motorForm.controls["benefits"].controls["entertainment"].value) {
      this.motorForm.controls["benefits"].controls["entertainmentAmount"].setValue(null);
      this.motorForm.controls["benefits"].controls["entertainmentAmount"].clearValidators();
    }
  }
 /*  selectedYearHandler(normalizedYear: Moment, dp: any) {
    const ctrlValue = this.motorForm.controls["yearManufactured"].value;

    ctrlValue!.year(normalizedYear.year());
    this.motorForm.controls["yearManufactured"].setValue(ctrlValue);
    dp.close();

    console.log(this.motorForm.controls["yearManufactured"].value, ctrlValue);
  } */
  // Validates car lists responses
  checkArrayStringType(value: any) {
    var arrayIsString = true;

    try {
      if (Array.isArray(value)) {
        if (value.length === 0) {
          arrayIsString = false;
        } else {
          value.forEach(function (item) {
            if (typeof item !== "string") {
              arrayIsString = false;
            }
          });
        }

        return arrayIsString;
      } else {
        arrayIsString = false;

        return arrayIsString;
      }
    } catch (error) {
      arrayIsString = false;

      return arrayIsString;
    }
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'Back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }
  
  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'Try again'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
}
